import { Navigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { FETCH_USER_ROLES } from 'gql/queries';
import { evaluate } from 'utilities/authUtils';

import Spinner from 'components/library/alerts/Spinner';

const RestrictedRoute = ({ children, allowFor }) => {

    const { loading, error, data } = useQuery(FETCH_USER_ROLES, {
        fetchPolicy: "cache-first",
    });

    if (loading) return <Spinner />;
    if (error) return "An error has occurred retrieving user roles. Unable to authorise access to this resource";
    if (!evaluate(data.userRoles, allowFor)) return <Navigate replace to="/unauthorised" />
    return children;
}

export default RestrictedRoute